import React, {Dispatch, SetStateAction, useState} from "react";
import {Alert, ConfigProvider, Slider} from "antd";
import dayjs, {Dayjs} from "dayjs";

export const PreventMinuteSliderComponent : React.FC<{
    preventMinutes : number,
    setPreventMinutes : Dispatch<SetStateAction<number>>,
    singlePayment : boolean
}> = (props) => {

    const {preventMinutes, setPreventMinutes, singlePayment} = props
    const [defaultDate]
        = useState<Dayjs>(dayjs().locale('pl')
        .set('hour', 7).set('minute', 0).set('second', 0).set('millisecond', 0))
    const handlePopulateDate = () : string => {
        let date = defaultDate.add(preventMinutes, 'minutes')
        return `Godzina ${date.format('HH:mm')} ${date < defaultDate.startOf('day')
            ? `dnia poprzedniego` : `dnia bieżącego`}`
    }

    return (
        <>
            <ConfigProvider
                theme={{
                    token: {
                        colorInfo: singlePayment ? "#c7c7c7" : "#C5B5F2",
                        colorText: singlePayment ? "#c7c7c7" : "#343434",
                    },
                }}
            >
                <Alert type="info"
                       showIcon={true}
                       description={singlePayment ?
                             'Godzina graniczna może być ustawiona tylko dla posiłków ze stawką dzienną'
                           : 'Godzina graniczna do której rodzic może zgłaszać ten posiłek'}
                       message={singlePayment ? 'Godzina graniczna niedostępna': handlePopulateDate()}/>
            </ConfigProvider>
            <ConfigProvider
                theme={{
                    components: {
                        Slider: {
                            handleColor: "#C5B5F2",
                            handleActiveColor: "#C5B5F2",
                            handleColorDisabled: "#c7c7c7",
                            dotActiveBorderColor: "#C5B5F2",
                            dotBorderColor: "#C5B5F2",
                            trackBg: "#C5B5F2",
                            trackBgDisabled: "#c7c7c7",
                            trackHoverBg: "#C5B5F2",
                            handleSize: 20,
                            handleSizeHover: 25

                        },
                    },
                }}
            >
                <Slider
                    value={preventMinutes}
                    min={-960}
                    max={180}
                    step={10}
                    onChange={(e) => setPreventMinutes(e)}
                    tooltip={{open: false}}
                    disabled={singlePayment}/>
            </ConfigProvider>
        </>
    )
}